var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 85,
    viewBox: "0 0 61 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8218 84.7313C50.345 84.7313 61.0001 79.752 61.0001 77.1871V60.3792C54.6507 64.1867 42.6843 66.1599 30.8218 66.1599C18.9598 66.1599 6.9922 64.1867 0.643555 60.3792L0.644512 77.1861C0.644512 79.752 11.2994 84.7313 30.8228 84.7313H30.8218Z",
    fill: "#3134DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0001 7.5442C61.0001 11.7108 47.4884 15.0894 30.8218 15.0894C14.1553 15.0894 0.643555 11.7108 0.643555 7.5442C0.643555 3.37762 14.1543 0 30.8218 0C47.4894 0 61.0001 3.37762 61.0001 7.5442Z",
    fill: "#8665CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8218 61.5161C50.345 61.5161 61.0001 56.5368 61.0001 53.9719V37.1649C54.6507 40.9715 42.6843 42.9447 30.8218 42.9447C18.9598 42.9447 6.9922 40.9715 0.643555 37.1639L0.644512 53.9719C0.644512 56.5368 11.2994 61.5161 30.8228 61.5161H30.8218Z",
    fill: "#009EE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8218 38.3034C50.345 38.3034 61.0001 33.324 61.0001 30.7592V13.9512C54.6507 17.7587 42.6843 19.7319 30.8218 19.7319C18.9598 19.7319 6.9922 17.7587 0.643555 13.9512L0.644512 30.178V30.7582C0.644512 33.3241 11.2994 38.3034 30.8228 38.3034L30.8218 38.3034Z",
    fill: "#8665CB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.fe704e06f3e06693c30efdeccd6d6c40.svg";
export { ForwardRef as ReactComponent };